import { Chip, Typography } from '@/components';
import { OfferDetails } from '../../types';
import { InterestSection } from './interest';
import { BuyerTypeSection } from './buyer-type';
import { OthersSection } from './others';
import { getStatusLabel } from '@/helpers';
import { FeedbackSection } from './feedback';

export function OfferDrawerContent({ offer }: { offer: OfferDetails }) {
  return (
    <>
      <section className="mb-4">
        <Typography as="p" color="primary" size="body-1" weight="normal">
          <span className="font-bold">{'Prospective Buyer: '}</span>
          {offer.company.name}
        </Typography>
        <span className="font-bold">Status: </span>
        <Chip className="ml-auto" color={offer.status.color}>
          {getStatusLabel(offer.status.name)}
        </Chip>
      </section>
      <hr />
      {offer.status.name === 'rejected' && (
        <>
          <div className="my-8">
            <FeedbackSection offer={offer} />
          </div>
          <hr />
        </>
      )}
      <div className="my-8">
        <InterestSection offer={offer} />
      </div>
      <hr />
      <div className="my-8">
        <BuyerTypeSection offer={offer} />
      </div>
      <hr />
      <div className="my-8">
        <OthersSection offer={offer} />
      </div>
    </>
  );
}
